export default "__VITE_ASSET__DuuTHe5n__"